import { defineComponent, computed, ref } from 'vue-demi';
import { OrMenuItemV3, OrIconV3, OrMenuV3, OrPopoverV3, useResponsive } from '@onereach/ui-components';
import { Chat } from '@or-sdk/chat';
import { u as useI18n } from './useI18n-25380ee3.js';
import { resolveComponent, openBlock, createBlock, withModifiers, withCtx, createTextVNode, toDisplayString, createElementBlock, createVNode, createCommentVNode, Fragment, renderList } from 'vue';
import { s as script$3 } from './ServiceNavigationButton-4dfba521.js';
import { s as script$2 } from './EmojiPicker-4cfbc9d9.js';

var script$1 = defineComponent({
  name: 'ServiceNavigationUtilitiesMenuItem',
  components: {
    OrMenuItemV3
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    handler: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const {
      t
    } = useI18n();
    const translatedLabel = computed(() => t(props.label));
    return {
      translatedLabel
    };
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrMenuItemV3 = resolveComponent("OrMenuItemV3");
  return openBlock(), createBlock(_component_OrMenuItemV3, {
    disabled: _ctx.isDisabled,
    icon: _ctx.icon,
    onClick: withModifiers(_ctx.handler, ["prevent"])
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.translatedLabel), 1 /* TEXT */)]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled", "icon", "onClick"]);
}

script$1.render = render$1;
script$1.__file = "src/components/ServiceNavigationUtilitiesMenu/ServiceNavigationUtilitiesMenuItem.vue";

function openChildWindow(url, windowConfig = {
  title: '',
  width: 835,
  height: 600
}) {
  const y = window.outerHeight / 2 + window.screenY - windowConfig.height / 2;
  const x = window.outerWidth / 2 + window.screenX - windowConfig.width / 2;
  const params = `
      toolbar=no,
      location=no,
      directories=no,
      status=no,
      menubar=no,
      resizable=no,
      copyhistory=no,
      scrollbars=no,
      width=${windowConfig.width},
      height=${windowConfig.height},
      top=${y},
      left=${x}
  `;
  const newWindow = window.open(url, windowConfig.title, params);
  newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
}

var script = defineComponent({
  name: 'ServiceNavigationUtilitiesMenu',
  components: {
    EmojiPicker: script$2,
    OrIconV3,
    OrMenuV3,
    ServiceNavigationUtilitiesMenuItem: script$1,
    ServiceNavigationButton: script$3,
    OrPopoverV3
  },
  props: {
    config: {
      type: Object,
      default: null,
      required: true
    },
    closeOnClickOutside: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  emits: ['open', 'close'],
  setup(props, {
    emit
  }) {
    const button = ref();
    const menu = ref();
    const emojiPickerPopover = ref();
    const {
      isMobile
    } = useResponsive();
    const isOpen = computed(() => {
      var _a, _b;
      return ((_a = menu.value) === null || _a === void 0 ? void 0 : _a.state) === 'open' || ((_b = emojiPickerPopover.value) === null || _b === void 0 ? void 0 : _b.state) === 'open';
    });
    const close = () => {
      var _a, _b;
      (_a = menu.value) === null || _a === void 0 ? void 0 : _a.close();
      (_b = emojiPickerPopover.value) === null || _b === void 0 ? void 0 : _b.close();
      emit('close');
    };
    const open = () => {
      var _a;
      (_a = menu.value) === null || _a === void 0 ? void 0 : _a.open();
      emit('open');
    };
    const toggleUtilsMenu = () => {
      if (isOpen.value) {
        close();
      } else {
        open();
      }
    };
    return {
      isOpen,
      isMobile,
      button,
      menu,
      open,
      close,
      toggleUtilsMenu,
      emojiPickerPopover
    };
  },
  computed: {
    items() {
      const items = [];
      // AI assist
      if (this.config.AI_ASSIST_CHAT_UI_URL) {
        items.push({
          icon: 'chat',
          label: 'services.aiassist.label',
          isDisabled: false,
          handler: () => {
            Chat.launchChatBotWindow({
              token: this.config.token,
              contextType: 'service-navigation',
              targetFlowName: '',
              title: '',
              chatUrl: this.config.AI_ASSIST_CHAT_UI_URL
            }, {
              discoveryUrl: this.config.SERVICE_DISCOVERY_API_URL
            });
          }
        });
      }
      //emoji picker
      items.push({
        icon: 'mood',
        label: 'components.emojipicker.label',
        isDisabled: false,
        handler: async () => {
          var _a;
          (_a = this.emojiPickerPopover) === null || _a === void 0 ? void 0 : _a.open();
        }
      });
      // Soft Phone
      if (this.config.SOFT_PHONE_UI_URL) {
        items.push({
          icon: 'phone_iphone',
          label: 'services.softphone.label',
          isDisabled: false,
          handler: () => {
            openChildWindow(this.config.SOFT_PHONE_UI_URL, {
              title: 'Soft phone',
              width: 550,
              height: 900
            });
          }
        });
      }
      return items;
    }
  }
});

const _hoisted_1 = {
  class: "contents"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrIconV3 = resolveComponent("OrIconV3");
  const _component_ServiceNavigationButton = resolveComponent("ServiceNavigationButton");
  const _component_EmojiPicker = resolveComponent("EmojiPicker");
  const _component_OrPopoverV3 = resolveComponent("OrPopoverV3");
  const _component_ServiceNavigationUtilitiesMenuItem = resolveComponent("ServiceNavigationUtilitiesMenuItem");
  const _component_OrMenuV3 = resolveComponent("OrMenuV3");
  return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(_component_ServiceNavigationButton, {
    ref: "button",
    "data-test": "utilities-menu",
    active: _ctx.isOpen,
    onClick: withModifiers(_ctx.toggleUtilsMenu, ["prevent"])
  }, {
    default: withCtx(() => [createVNode(_component_OrIconV3, {
      size: _ctx.isMobile ? 'm' : 'xl',
      icon: "widgets",
      color: "inherit",
      variant: "filled"
    }, null, 8 /* PROPS */, ["size"])]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["active", "onClick"]), createVNode(_component_OrPopoverV3, {
    ref: "emojiPickerPopover",
    trigger: _ctx.button && _ctx.button.root
  }, {
    default: withCtx(() => [_ctx.emojiPickerPopover && _ctx.emojiPickerPopover.state === 'open' ? (openBlock(), createBlock(_component_EmojiPicker, {
      key: 0
    })) : createCommentVNode("v-if", true)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"]), createVNode(_component_OrMenuV3, {
    ref: "menu",
    trigger: _ctx.button && _ctx.button.root
  }, {
    default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, item => {
      return openBlock(), createBlock(_component_ServiceNavigationUtilitiesMenuItem, {
        key: item.label,
        handler: item.handler,
        label: item.label,
        icon: item.icon,
        "is-disabled": item.isDisabled
      }, null, 8 /* PROPS */, ["handler", "label", "icon", "is-disabled"]);
    }), 128 /* KEYED_FRAGMENT */))]),

    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["trigger"])]);
}

script.render = render;
script.__file = "src/components/ServiceNavigationUtilitiesMenu/ServiceNavigationUtilitiesMenu.vue";

export { script as s };
